import { render } from "./OrdersManagerOffersStage.vue?vue&type=template&id=34c482b0&scoped=true"
import script from "./OrdersManagerOffersStage.vue?vue&type=script&lang=js"
export * from "./OrdersManagerOffersStage.vue?vue&type=script&lang=js"

import "./OrdersManagerOffersStage.vue?vue&type=style&index=0&id=34c482b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c482b0"]])

export default __exports__